import {Component, ContentChild, Directive, Input} from '@angular/core';

@Directive({
    selector: '[widgetActions]',
    standalone: false
})
export class WidgetActionsDirective {
}

@Component({
    selector: 'widget',
    templateUrl: './widget.component.html',
    standalone: false
})
export class WidgetComponent {

  @Input() title!: string;
  @Input() subTitle!: string;
  @ContentChild(WidgetActionsDirective) actions!: WidgetActionsDirective;
}
